export enum LifecycleEvent {
    Initialized = "Lifecycle_Initialized",
}